import { Component, Injector } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { UserVendorService as UserVendorServiceProxy } from 'src/app/proxy/user-vendors';
import { UserVendorService } from '../../services/user-vendor.service';
import { firstValueFrom } from 'rxjs';
import { VendorDto } from 'src/app/proxy/vendors';

@Component({
  selector: 'app-change-vendor-modal',
  templateUrl: './change-vendor-modal.component.html',
  standalone: false,
})
export class ChangeVendorModalComponent extends AppBaseComponent {

  isVisible = false;
  vendorsItems: VendorDto[] = [];
  currentVendor: VendorDto;

  constructor(
    injector: Injector,
    private readonly _userVendorServiceProxy: UserVendorServiceProxy,
    private readonly _userVendorService: UserVendorService) {
    super(injector);
  }

  async show(): Promise<void> {
    await this.loadCurrentUserVendor();
    await this.getAvailableVendors();
  }

  async updateVendor(vendor: VendorDto): Promise<void> {
    try {
      this.showLoading();
      await firstValueFrom(this._userVendorServiceProxy.updateCurrentUserVendorByVendorId(vendor.id));
    } finally {
      this.hideLoading();
      this._userVendorService.refreshCurrentUserVendor();
      this.isVisible = false;
    }
  }

  private async loadCurrentUserVendor(): Promise<void> {
    this.currentVendor = await this._userVendorService.getCurrentUserVendor();
  }

  private async getAvailableVendors(): Promise<void> {
    try {
      this.showLoading();
      this.vendorsItems = await firstValueFrom(this._userVendorServiceProxy.getCurrentUserAvailableVendors());
    } finally {
      this.isVisible = true;
      this.hideLoading();
    }
  }
}
